import { server } from 'config'
export const ensureHTTPPrefix = (route: string) => {
  if (!route.startsWith('http')) {
    return `${server.protocol}://${route}`
  }
  return route
}
